import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useServiceNationUrl } from '../../../common/utils/useServiceNationUrl';
import { useNavigationUtils } from '../../../common/utils/useNavigationUtils';
import { TestIds } from '../../../assets/testIds';
import { ListViewButton } from '../../../common/ListViewButton';

export function HistoricalRebateData() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { buildServiceNationUrl } = useServiceNationUrl();
  const { openExternalLink } = useNavigationUtils();

  const handleViewRebateData = async () => {
    try {
      const url = await buildServiceNationUrl('purchase-reporting');
      openExternalLink(url);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to generate Service Nation SSO token', error);
    }
  };

  return (
    <Box
      data-testid={TestIds.walletPage.historicalRebateData}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3.125),
        padding: theme.spacing(3.125),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${theme.palette.grey[200]}`,
        [theme.breakpoints.down('sm')]: {
          padding: `${theme.spacing(1.875)} ${theme.spacing(1)}`,
        },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          lineHeight: theme.spacing(3),
          [theme.breakpoints.down('sm')]: {
            fontSize: theme.spacing(1.75),
          },
        }}
      >
        {t('wallet.historicalRebateData')}
      </Typography>
      <ListViewButton
        onBtnClick={handleViewRebateData}
        listViewId={TestIds.walletPage.historicalRebateData}
        btnLabel={t('wallet.viewRebateData') as string}
      />
    </Box>
  );
}
